import { useState } from 'react';
import { SelectOption } from '../searchableSelect/searchableSelectTypes';
import { useTimer } from '../../context/TimerContext';
import { useFetchSkills } from '../../hooks/useFetchSkills';
import { ITimer } from '../../interface/timer';

/** The props `SearchableSelect` needs to pick a timer's skill, from the same list the picker screen uses. */
export const useTimerSkillSelect = () => {
  const { timer, updateTimer } = useTimer();
  const [searchValue, setSearchValue] = useState('');
  const {
    data: skills,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useFetchSkills({
    sortBy: ['name:ASC'],
    pageSize: 50,
    search: searchValue,
    fields: ['name'],
  });

  const options: SelectOption[] = skills.map(({ id, name }) => ({ value: id, label: name }));
  const value: SelectOption | null = timer?.skill?.id
    ? { value: timer.skill.id, label: timer.skill.name }
    : null;

  const onChange = (option: SelectOption) => {
    const skill = skills.find(({ id }) => id === option.value);
    if (!skill) return;
    updateTimer({ ...timer, skillId: skill.id, skill } as ITimer);
  };

  return {
    options,
    value,
    onChange,
    onSearch: setSearchValue,
    onLoadMore: fetchNextPage,
    hasMore: Boolean(hasNextPage),
    loading: isLoading,
    loadingMore: isFetchingNextPage,
  };
};
